module.exports = __webpack_public_path__ + "img/icon_voting_count.fd36b17b.svg";